import { useQuery } from '@apollo/client';

import { getShopId } from '../../ProductBaseInfo/VoucherDiscount/VoucherDiscountInfo/queries/__generated__/getShopId';
import getShopIdQuery from '../../ProductBaseInfo/VoucherDiscount/VoucherDiscountInfo/queries/getShopId.graphql';

import { productCodesForSeoTest } from './constants';

// NOTE: https://notino.tpondemand.com/entity/245903-open-pd-description-in-mobile-view
const useIsAboutProductSeoTest = (productCode: string) => {
  const { data } = useQuery<getShopId>(getShopIdQuery, {
    ssr: true,
  });

  const isHungary = data?.RequestHeaders?.shopId === 'notino.hu';
  return isHungary && productCodesForSeoTest.includes(productCode);
};

export default useIsAboutProductSeoTest;
